import CrudPage from '@modules/cruds/CrudPage';
import * as yup from 'yup';
import DeviceTypeForm from './DeviceTypeForm';
import { defaultConfigComponent } from './DeviceTypes';

const DeviceTypeSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const DeviceTypePage = () => {
  return (
    <CrudPage
      key="deviceTypePage"
      configComponent={defaultConfigComponent}
      form={DeviceTypeForm}
      validationSchema={DeviceTypeSchema}
    />
  );
};

export default DeviceTypePage;
